var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWriteing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_3",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m63 21.536c0-2.501-2.035-4.536-4.536-4.536-1.211 0-2.351.472-3.207 1.329l-2.964 2.964-3.293 3.293v-9.666c3.387-.488 6-3.401 6-6.92 0-3.86-3.14-7-7-7h-40c-3.86 0-7 3.14-7 7v50c0 .552.448 1 1 1h5v3c0 .552.448 1 1 1h40c.552 0 1-.448 1-1v-24.586l9.707-9.707 1.027-1.027c-.518 2.58-1.781 4.952-3.683 6.855l-4.757 4.757 1.414 1.414 4.757-4.757c2.838-2.838 4.425-6.586 4.518-10.585.647-.802 1.017-1.782 1.017-2.828zm-6.329-1.793c.479-.479 1.116-.743 1.793-.743 1.398 0 2.536 1.138 2.536 2.536 0 .677-.264 1.314-.743 1.793l-2.257 2.257-3.586-3.586zm-3.671 3.671 1.086 1.086-12.586 12.586-1.086-1.086zm-23.783 26.389 2.057-4.115 3.038 3.038-4.115 2.057zm3.197-5.803 6.586-6.586 3.586 3.586-6.586 6.586zm15.586-41c2.757 0 5 2.243 5 5s-2.243 5-5 5h-35.11c1.3-1.272 2.11-3.042 2.11-5s-.81-3.728-2.11-5zm-39 9.899v-2.899c0-.551.449-1 1-1h2.899c-.399 1.956-1.943 3.5-3.899 3.899zm-6 44.101v-49c0-2.757 2.243-5 5-5 2.414 0 4.434 1.721 4.899 4h-2.899c-1.654 0-3 1.346-3 3v47zm44 4h-38v-46h38v11.586l-4.414 4.414h-29.586v2h27.586l-2 2h-25.586v2h23.586l-6.293 6.293c-.078.078-.129.171-.176.265l-.011-.006-3 6c-.192.385-.117.85.188 1.154l.292.294-2.293 2.293 1.414 1.414 2.293-2.293.293.293c.192.192.448.293.707.293.151 0 .305-.035.447-.105l6-3-.006-.011c.094-.047.187-.098.265-.176l8-8 2.294-2.294zm-3-21.414-1.086-1.086 12.586-12.586 1.086 1.086z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 19h30v2h-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 23h30v2h-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 27h30v2h-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 51h11v2h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 55h30v2h-30z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWriteing);
export default __webpack_public_path__ + "static/media/writeing.79ed5c982211fe1112923d43a4eb1a1e.svg";
export { ForwardRef as ReactComponent };